import Icon from '@kk/ui/components/Icon';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export default function ReceiptNewAgreement() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { agreementId: agreementIdParam } = useParams();
  const location = useLocation();

  const agreementIdFromState =
    typeof location.state === 'object' &&
    location.state !== null &&
    'agreementId' in location.state &&
    typeof location.state.agreementId === 'string'
      ? location.state.agreementId
      : undefined;

  const agreementId = agreementIdParam
    ? decodeURIComponent(agreementIdParam)
    : agreementIdFromState;

  return (
    <div className="mx-auto mt-24 w-full max-w-230 px-4">
      <div className="rounded-lg border border-neutral-10 bg-white p-6 shadow-md-8 md:p-8">
        <div className="mb-6 flex flex-col gap-y-6">
          <div className="items-top flex justify-between">
            <Icon
              type="check"
              size="large"
              className="bg-green-5 rounded-full p-0 text-green-100"
            />
          </div>

          <div>
            <h1 className="typ-headline-md text-neutral-200">
              {t('common.receipt.newAgreement.title')}
            </h1>

            <p className="mt-2 text-sm text-neutral-110">
              {t('common.receipt.newAgreement.subtitle')}
              <span className="font-bold">{agreementId ?? '-'}</span>
            </p>
            <p className="mt-3 text-sm text-neutral-110">
              {t('common.receipt.newAgreement.description')}
            </p>
          </div>
        </div>

        <div className="mt-6 border-t border-neutral-10 pt-6">
          <div className="flex justify-end">
            <button
              type="button"
              className="rounded-md bg-blue-110 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-100 focus:outline-hidden focus:ring-2 focus:ring-blue-20"
              onClick={() => navigate('/new-agreement')}
            >
              {t('button.close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
